import React from "react";
import { useSearchParams } from "react-router-dom";
import { Users, Shield } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { UsersTable } from "../users/UsersTable";
import RolesAndPermissions from "../roles/RolesAndPermissions";

interface TeamPageProps {
  defaultTab?: "users" | "roles";
}

const TeamPage: React.FC<TeamPageProps> = ({ defaultTab = "users" }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const activeTab =
    tabParam === "users" || tabParam === "roles" ? tabParam : defaultTab;

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value });
  };

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Team &amp; Permissions
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mt-1">
          Manage team members and their roles &amp; permissions
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList className="mb-6">
          <TabsTrigger value="users" className="flex items-center gap-2">
            <Users className="h-4 w-4" />
            Users
          </TabsTrigger>
          <TabsTrigger value="roles" className="flex items-center gap-2">
            <Shield className="h-4 w-4" />
            Roles &amp; Permissions
          </TabsTrigger>
        </TabsList>

        <TabsContent value="users">
          <UsersTable />
        </TabsContent>

        <TabsContent value="roles">
          <RolesAndPermissions />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default TeamPage;
